import {
    CLEAR_SET_RESULT, ERROR_SET_RESULT,
    FETCH_SET_RESULT,
    LIST_SET_RESULT, MODIFY_SET_RESULT
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    data: {},
    fullData: {
        items: []
    },
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_SET_RESULT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_SET_RESULT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
                fullData: {
                    ...payload.data,
                    items: Object.values(
                        payload.data?.items.reduce((acc, cur) => {
                            if (!acc[cur.columnNumber]) acc[cur.columnNumber] = [];
                            acc[cur.columnNumber].push(cur);
                            return acc;
                        }, {})
                    )
                }
            };
        case MODIFY_SET_RESULT:
            return {
                ...state,
                isLoading: true
            };
        case ERROR_SET_RESULT:
            return {
                ...state,
                isLoading: false
            };
        case CLEAR_SET_RESULT:
            return {
                ...init
            };
        default:
            return state;
    }
}
